export enum StoragePersistKeyEnum {
  CurrentUserHotel = '__CurrentUserHotel__',
  AccessToken = 'access_token',
  CurrentUser = 'currentUser',
}
